module.exports = __webpack_public_path__ + "img/3dvalve_orange.6e19088e.png";